import React, { useEffect, useState } from 'react'
import useCountDown from 'react-countdown-hook'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import moment from 'moment'

import { Button, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'

import FixedModalHeader from 'components/common/Modal/FixedHeader'
import { useAppSelector } from 'redux/hooks'
import { logout } from 'redux/user/user-actions'
import { themeStyles } from 'themes'

const seconds = 300

const chances = {
    time: 1000 * seconds,
}

function AccountStatusChangedForm({ classes, handleClose }) {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { currentUser } = useAppSelector(state => state.user)

    const [timeLeft, { start, reset }] = useCountDown(chances.time, 1000)
    const [showTimer, setShowTimer] = useState(false)

    const { accountDeactivated } = { ...currentUser }

    const hardRefresh = () => {
        if (accountDeactivated) {
            dispatch(logout())
        } else {
            window.location.replace('/')
        }
        handleClose()
    }

    useEffect(() => {
        start(chances.time)
        setShowTimer(true)
    }, [])

    useEffect(() => {
        if (timeLeft <= 0 && showTimer) {
            setShowTimer(false)
            hardRefresh()
        }
    }, [timeLeft])

    useEffect(() => () => reset(), [])

    return (
        <>
            <FixedModalHeader backEnabled={false} />
            <div className={classes.modalSuccessContent}>
                <div className={classes.modalSuccess}>
                    <div className={classes.modalSuccessTitle}>
                        <Typography data-sta-id="account-status-changed-form-component-h1-title" variant="h1">
                            {t('AccountStatusChangedForm.AccountStatus')}
                        </Typography>
                    </div>
                    <Typography data-sta-id="account-status-changed-form-component-h6-subtitle" variant="subtitle2">
                        {t('AccountStatusChangedForm.RefreshPage')}
                    </Typography>
                    <Typography data-sta-id="account-status-changed-form-component-h6-timer" variant="subtitle2">
                        {showTimer && (
                            <strong>
                                {`${moment(timeLeft).minutes()}`.padStart(2, '0')}:{`${moment(timeLeft).seconds()}`.padStart(2, '0')}
                            </strong>
                        )}
                    </Typography>
                </div>
                <Button
                    type="button"
                    className={classes.modalButton}
                    variant="contained"
                    color="primary"
                    onClick={hardRefresh}
                    data-sta-id="account-status-changed-form-component-button"
                >
                    {t('AccountStatusChangedForm.RefreshPage')}
                </Button>
            </div>
        </>
    )
}

export default withStyles(themeStyles.useModalStyles)(AccountStatusChangedForm)
